import type * as Api from 'Api'

export const registrationFormErrorMessages: Dictionary<Dictionary<string>> = {
  email: {
    default: 'E-mail уже занят',
    required: 'Введите электронную почту',
    email: 'Электронная почта введена неверно',
  },
  password: {
    default:
      'Пароль ненадежный. Используйте прописные и строчные буквы, цифры и спецсимволы',
    required: 'Введите пароль',
    length: 'Пароль слишком короткий (Минимум 5 симв.)',
    format: 'Пароль не может содержать Кириллицу',
  },
  passwordConfirmation: {
    default: 'Пароли не совпадают',
    required: 'Введите пароль',
  },
}

export const registrationErrorHandbook: Api.ErrorsHandbook<
  'default' | 'registration'
> = {
  default: [],
  registration: [
    {
      status: 1,
      code: 401,
      message: 'E-mail уже занят',
    },
  ],
}
